import React from "react";

import {cn} from "@isudio/utils";

const RowWrapper: React.FC<React.PropsWithChildren<{
  className?: string
}>> = ({
         className,
         children,
       }) => (
  <div
    className={cn("flex w-full ml-auto mr-auto", className)}>
    {children}
  </div>
);

RowWrapper.displayName = "RowWrapper";
export {RowWrapper};